export default __webpack_public_path__ + "static/assets/no_appointments.4b146851.png";